// extracted by mini-css-extract-plugin
module.exports = {"content":"implements_content__2VMQx","center":"implements_center__3mqGW"};